import React from "react";
import { List, Datagrid, TextField } from "react-admin";
// import SimpleChipField from "../SimpleChipField";
// import { countries } from "../../data";

const PlaceList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="country" />
        <TextField source="city" />
        <TextField source="street" />
        <TextField source="fullAddress" />
      </Datagrid>
    </List>
  );
};

export default PlaceList;
